import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float, ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { Konfession } from '../../../../db/enums/misc-enums.js';

@Entity()
export class SteuerFreibetraege extends AdornisEntity {
  static override _class = 'SteuerFreibetraege';

  /** in EUR */
  @Field(() => Float) jahresFreibetrag: Maybe<number>;

  /** in EUR */
  @Field(() => Float) jahresHinzurechnungsbetrag: Maybe<number>;

  /** in EUR */
  @Field(() => Float) monatsFreibetrag: Maybe<number>;

  /** in EUR */
  @Field(() => Float) monatsHinzurechnungsbetrag: Maybe<number>;
}

@Entity()
export class ANSteuerInfos extends AdornisEntity {
  static override _class = 'ANSteuerInfos';

  @Field(() => String, { default: v => v ?? 'Hauptarbeitgeber' })
  verfuegbarkeit!: 'Hauptarbeitgeber' | 'Nebenarbeitgeber';

  @Field(() => String)
  steuerIdentNr: Maybe<string>;

  @Field(() => String)
  steuerklasse: Maybe<'1' | '2' | '3' | '4' | '5' | '6'>;

  @Field(() => String)
  steuerklassePartner: Maybe<'1' | '2' | '3' | '4' | '5' | '6'>;

  @Field(() => Float, { default: v => v ?? 0.5 })
  factor: Maybe<number>;

  @Field(() => Float, { default: v => v ?? 0 })
  kinderFreibetrag: Maybe<number>;

  @Field(() => String)
  konfessionPartner: Maybe<Konfession>;

  @Field(() => ID)
  elterneigenschaftID: Maybe<string>;

  @Field(() => SteuerFreibetraege)
  steuerfreibetraege: Maybe<SteuerFreibetraege>;
}
